(function($){
        
	// Add Loaded Class
	$('.ptx-stripelogin').addClass('ptx-stripelogin--loaded');
  
})(jQuery);